export default "__VITE_ASSET__efdd9ab5__"